import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import { AppDisbatch } from "../../../contexts/app";
import { TypesValue } from "../../../contexts/types";
import { makeid } from "../../../utils/pageactions";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";

export default function CustomProps({ block, path, onChange }) {
  const [props, setProps] = useState({});
  const disbatch = useContext(AppDisbatch);

  useEffect(() => {
    if (block.customProps) {
      setProps(block.customProps);
    }
  }, [block.customProps]);

  const handleChange = (props) => {
    const newBlock = { ...block };
    newBlock.customProps = props;
    onChange(newBlock);
    disbatch({
      type: "updateComponent",
      component: { id: block.id, key: "customProps", value: props },
    });
  };

  const handleAdd = () => {
    const id = makeid(16);
    const newProps = { ...props };
    newProps[id] = { name: "", type: "Text", list: false };
    setProps(newProps);
    handleChange(newProps);
  };

  const handleUpdate = (v, i) => {
    const newProps = { ...props };
    newProps[i] = v;
    setProps(newProps);
    handleChange(newProps);
  };

  const handleDelete = (i) => {
    const newProps = { ...props };
    delete newProps[i];
    setProps(newProps);
    handleChange(newProps);
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className={styles.propInput}
    >
      <div className={styles.propTitle}>Custom Props</div>
      {Object.keys(props).map((k) => {
        return (
          <PropItem
            id={k}
            value={props[k]}
            key={k}
            onDelete={() => handleDelete(k)}
            onChange={(v) => handleUpdate(v, k)}
          />
        );
      })}
      <div onClick={handleAdd} className={styles.addProp}>
        Add Prop
      </div>
    </div>
  );
}

const PropItem = ({ value, id, onChange, onDelete }) => {
  const [name, setName] = useState(value.name);
  const types = useContext(TypesValue);

  const changeName = () => {
    const newValue = { ...value };
    newValue.name = name;
    onChange(newValue);
  };

  const changeType = (v) => {
    const newValue = { ...value };
    newValue.type = v;
    onChange(newValue);
  };

  const changeList = () => {
    const newValue = { ...value };
    newValue.list = !value.list;
    onChange(newValue);
  };
  return (
    <div className={styles.propItem}>
      <div>
        <div className={styles.propName}>Prop Name</div>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={"input"}
          onBlur={changeName}
        />
      </div>
      <div style={{ display: "flex", marginTop: 8 }}>
        <div style={{ flexGrow: 1, marginRight: 12 }}>
          <div className={styles.propName}>Prop Type</div>
          <select
            value={value.type}
            onChange={(e) => changeType(e.target.value)}
            className={"dropdown"}
          >
            {types.map((t) => {
              return <option value={t.name}>{t.displayName}</option>;
            })}
          </select>
        </div>
        <div style={{ minWidth: 48 }}>
          <div className={styles.propName}>List?</div>
          {value.list ? (
            <MdCheckBox onClick={changeList} className={styles.checkbox} />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={changeList}
              className={styles.checkbox}
            />
          )}
        </div>
      </div>
      <div onClick={onDelete} className={styles.delete}>
        Delete
      </div>
    </div>
  );
};
